import type { UnitPreference } from '../types';
import { cmToInches, inchesToCm } from '../units';
import { Field } from './Field';

type WaistInputProps = {
  label: string;
  /** Always in cm. */
  value_cm: number | null;
  onChange: (next_cm: number | null) => void;
  unit: UnitPreference;
  hint?: string;
};

// Mirrors HeightInput.tsx's cm/imperial toggle pattern, but waist is a single
// inches value in imperial mode (not ft/in split) — that's how waist
// measurements are normally read off a tape measure.
export function WaistInput({ label, value_cm, onChange, unit, hint }: WaistInputProps) {
  if (unit === 'imperial') {
    return (
      <Field label={label} hint={hint}>
        <div className="unit-row">
          <input
            className="input"
            type="number"
            inputMode="decimal"
            step="0.1"
            min="0"
            placeholder="e.g. 32"
            value={value_cm === null ? '' : cmToInches(value_cm)}
            onChange={(e) => {
              if (e.target.value === '') return onChange(null);
              const n = Number(e.target.value);
              if (!Number.isFinite(n)) return;
              onChange(inchesToCm(n));
            }}
          />
          <div className="input input--small" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'default' }}>
            in
          </div>
        </div>
      </Field>
    );
  }

  return (
    <Field label={label} hint={hint}>
      <div className="unit-row">
        <input
          className="input"
          type="number"
          inputMode="decimal"
          step="0.1"
          min="0"
          placeholder="e.g. 81"
          value={value_cm ?? ''}
          onChange={(e) => {
            if (e.target.value === '') return onChange(null);
            const n = Number(e.target.value);
            if (!Number.isFinite(n)) return;
            onChange(+n.toFixed(1));
          }}
        />
        <div className="input input--small" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'default' }}>
          cm
        </div>
      </div>
    </Field>
  );
}
